import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {StockItemsSelectors} from '../store/selectors';
import {StockItemsActions} from '../store';

@Injectable()
export class StockItemsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadStockItemsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(true))
    );
  }

  loadStockItemsDone(): Observable<boolean> {
    return this.store.pipe(
      select(StockItemsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(StockItemsActions.ReadStockItems());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
